import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=010044c5&scoped=true&"
import script from "./customer.component.ts?vue&type=script&lang=ts&"
export * from "./customer.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer.scss?vue&type=style&index=0&id=010044c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010044c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010044c5')) {
      api.createRecord('010044c5', component.options)
    } else {
      api.reload('010044c5', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=010044c5&scoped=true&", function () {
      api.rerender('010044c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/customer.vue"
export default component.exports